import { render, staticRenderFns } from "./MultiItemCategorySelect.vue?vue&type=template&id=0d8adc63&"
import script from "./MultiItemCategorySelect.vue?vue&type=script&lang=js&"
export * from "./MultiItemCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports